import { render, staticRenderFns } from "./MenubarItem.vue?vue&type=template&id=dc88ab22&"
import script from "./MenubarItem.vue?vue&type=script&lang=js&"
export * from "./MenubarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports